import React, { useState, useRef } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { Calendar } from 'grommet'
import { useOnClickOutside } from '@services/layout'
import * as Utils from '@services/utils'
import { cavronDownIcon } from '@assets/images'
import {
    SelectBtn,
    FormInputContainer,
    FormInputLabel,
} from '@appearance/styled'
import i18n from '@localization/i18n'

export default ({ date, onChange, from, label, width, height = 38 }) => {
    const ref = useRef()
    const [open, setOpen] = useState(false)
    const toggleOpen = () => {
        setOpen(!open)
    }
    useOnClickOutside(ref, () => setOpen(false))
    const fixDate = (date) => (from ? Utils.getStartOfDay(date) : moment(date))

    return (
        <StyledFormInputContainer width={width} ref={ref} open={open}>
            <FormInputLabel lang={i18n.locale}>{label}</FormInputLabel>
            <StyledSelectBtn height={height} onClick={toggleOpen}>
                <Text>{moment(date).format('DD/MM/YY')}</Text>
                <ArrowIcon src={cavronDownIcon} />
            </StyledSelectBtn>
            <CalendarWrapper open={open}>
                <Calendar
                    date={date || new Date().toISOString()}
                    onSelect={(dete) => onChange(fixDate(dete).toISOString())}
                    size={'small'}
                />
            </CalendarWrapper>
        </StyledFormInputContainer>
    )
}
const StyledFormInputContainer = styled(FormInputContainer)`
    position: relative;
    z-index: ${(p) => (p.open ? 1 : 0)};
`

const StyledSelectBtn = styled(SelectBtn)`
    height: ${(p) => p.height}px;
    background-color: #fff;
    border-radius: 4px;
    border: solid 1px #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
`

const ArrowIcon = styled.img`
    width: 20px;
    height: 20px;
    margin: 0 8px;
`

const Text = styled.div`
    padding: 0px 12px;
`

const CalendarWrapper = styled.div`
    background-color: #fff;
    position: absolute;
    left: 20px;
    top: 80px;
    padding: 12px;
    border-radius: 4px;
    border: solid 1px #ccc;
    direction: ltr;
    text-align: left;
    visibility: ${(p) => (p.open ? 'initial' : 'hidden')};
`
